import axios from '@/plugins/axios';
import { Response } from '@/types/common/Rest';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import { handleApiResponse } from '@/utils/request';
import { IFiltroLegislacao, PageLegislacao } from '../types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/legislacao`;

class LegislacaoService {
  public async consultarLegislacao(
    cdLegislacao: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Promise<Response<any>> {
    const url = `${BASE_URL}/find/${cdLegislacao}`;
    return handleApiResponse(() => axios.get(url));
  }

  public async consultarListaLegislacao(
    filtro: IFiltroLegislacao
  ): Promise<Response<PageLegislacao>> {
    const url = `${BASE_URL}/find/legislacoes`;
    return handleApiResponse(() => axios.post(url, filtro));
  }
}

export default new LegislacaoService();
